module.exports = __webpack_public_path__ + "assets/img/65x_519_4.6b126018.jpg";